import { axios } from '@/services/axios';

const updateTCAPUser = async (formData, scope) => {
    const res = await axios.put('/TCAPUser', formData, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};
export default updateTCAPUser;
